module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon6_native.a5f86a0f.png";